export default __webpack_public_path__ + "static/media/yes-queen.323633bd.webp";